import { render, staticRenderFns } from "./addDivide.vue?vue&type=template&id=3d224465&scoped=true&"
import script from "./addDivide.vue?vue&type=script&lang=js&"
export * from "./addDivide.vue?vue&type=script&lang=js&"
import style0 from "./addDivide.vue?vue&type=style&index=0&id=3d224465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d224465",
  null
  
)

export default component.exports